import NewsActions from './Actions'

export const getColumns = (rowId, setRowId) => [
  {
    field: 'titulo',
    headerName: 'Título',
    headerAlign: 'center',
    flex: 2,
    minWidth: 180,
    editable: true,
  },
  {
    field: 'url',
    headerName: 'URL',
    headerAlign: 'center',
    flex: 2,
    minWidth: 200,
    editable: true,
  },
  {
    field: 'contenido',
    headerName: 'Contenido',
    headerAlign: 'center',
    flex: 3,
    minWidth: 260,
    editable: true,
  },
  {
    field: 'idProyecto',
    headerName: 'Proyecto',
    headerAlign: 'center',
    flex: 1,
    minWidth: 120,
    editable: true,
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Habilitado',
    type: 'boolean',
    flex: 1,
    minWidth: 120,
    editable: true,
  },
  {
    field: 'fechaRegistro',
    headerAlign: 'center',
    headerName: 'Fecha',
    flex: 1,
    minWidth: 140,
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => <NewsActions {...{ params, rowId, setRowId }} />,
    minWidth: 100,
    flex: 1,
  },
]
